<button (click)="confirmation = true"
        class="critical">
  <ng-content></ng-content>
</button>
@if (confirmation) {
  <div class="confirmation-panel">
    <button (click)="confirmation = false">
      {{ 'common.actions.cancel' | translate }}
    </button>
    <button (click)="confirmation = false; confirmedClick.emit()"
            class="critical">
      {{ 'common.actions.confirm' | translate }}
    </button>
  </div>
}
